import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, Heart } from 'lucide-react';
import { useCart } from '../context/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart, toggleWishlist, wishlist } = useCart();
  const navigate = useNavigate();
  
  const isInWishlist = wishlist?.some((item) => item._id === product._id);

  const handleBuyNow = (e) => {
    e.preventDefault();
    addToCart(product);
    // Directs user to the cart page while marking this product as the primary reference item
    navigate('/cart', { state: { targetProductId: product._id } });
  };

  return (
    <div className="group rounded-xl border border-slate-200 bg-white p-1.5 shadow-sm transition-all duration-200 hover:border-slate-300 hover:shadow-md flex flex-col justify-between h-full">
      <div>
        <Link to={`/product/${product._id}`} className="block mb-1.5 w-full overflow-hidden rounded-lg bg-slate-50/50 p-1.5">
          <div className="w-full h-24 sm:h-28 flex items-center justify-center bg-white rounded-md">
            <img 
              src={product?.images?.[0]?.url || product.image}
              alt={product.name}
              className="max-h-full max-w-full object-contain transition duration-200 transform scale-[0.85] group-hover:scale-[0.88]"
              loading="lazy"
            />
          </div>
        </Link>

        <div className="px-0.5">
          <div className="flex items-start justify-between gap-2">
            <h3 className="truncate text-xs font-semibold text-slate-800 leading-tight group-hover:text-slate-900 flex-1">
              {product.name}
            </h3>
          </div>

          <div className="mt-2 mb-2 flex items-center justify-between gap-1">
            <div className="flex items-center gap-1.5">
              <span className="text-sm font-bold text-slate-900">₹{product.price}</span>
            </div>
            
            <div className="flex items-center gap-1">
              <span className={`rounded px-1.5 py-0.5 text-[9px] font-medium ${product.stock > 20 ? 'bg-slate-100 text-slate-600' : 'bg-amber-50 text-amber-700'}`}>
                {product.stock} left
              </span>
              <button
                onClick={() => toggleWishlist(product)}
                className="shrink-0 p-0.5 rounded transition hover:bg-slate-50"
                aria-label={isInWishlist ? 'Remove from wishlist' : 'Add to wishlist'}
              >
                <Heart size={12} className={isInWishlist ? 'fill-red-500 text-red-500' : 'text-slate-400'} />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex gap-1.5 mt-auto pt-0.5">
        <button 
          onClick={handleBuyNow} 
          disabled={product.stock === 0} 
          className="flex-1 flex items-center justify-center gap-1 rounded-lg bg-indigo-600 px-2 py-1.5 text-xs font-semibold text-white transition hover:bg-indigo-700 disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-400"
        >
          Buy Now
        </button>
        <button 
          onClick={() => addToCart(product)} 
          disabled={product.stock === 0}
          className="flex-1 flex items-center justify-center gap-1 rounded-lg bg-slate-100 px-2 py-1.5 text-xs font-semibold text-slate-700 transition hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-40" 
          aria-label="Add to cart" 
          title="Add to cart"
        >
          <ShoppingCart size={12} />
          Cart
        </button>
      </div>
    </div>
  );
};

export default ProductCard;